import React, { useEffect, useState } from "react";
import Members from "./home/members";
import { HomeContainer } from "../styled/groupDetails";
import Slide from "../common/slide";
import { useNavigate, useOutletContext, useParams } from "react-router";
import { useSelector } from "react-redux";
import axios from "axios";
import Feed from "./home/feed";
import { toast } from "react-toastify";

const GroupHome = ({ changeTab }) => {
  const { member, members, group } = useOutletContext();

  const { id } = useParams();

  const navigate = useNavigate();
  const user = useSelector((state) => state?.user?.data[0]);

  const [blog, setBlog] = useState([]);
  const [feed, setFeed] = useState([]);

  useEffect(() => {
    if (!id || isNaN(id)) return;

    getBlog();
    getFeed();
  }, [id]);

  const getBlog = async () => {
    const url = "/api/combineSearch";
    const body = {
      groupNo: id,
      searchType: "B",
      offset: 0,
      pageNumber: 0,
      pageSize: 10,
      paged: true,
    };

    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        setBlog(res?.data?.blogPageList?.content || []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getFeed = async () => {
    const url = "/api/grpFeedList";
    const body = {
      gbn: [id],
      offset: 0,
      pageNumber: 0,
      pageSize: 4,
      paged: true,
    };

    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        setFeed(res.data.content);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <HomeContainer>
      <Feed
        feed={feed}
        clickFeed={(feedNo) =>
          member
            ? navigate(`/group/${id}/community`, { state: { type: "feed", target: feedNo } })
            : toast.error("그룹 가입 후 이용 가능합니다.")
        }
      />
      <Members members={members} group={group} member={member} />
      <Slide
        info={{
          title: `${group?.groupName}의\n소식들😉`,
          description: "다양한 소식을 확인해보세요!",
          nav: {
            label: "자세히 보러가기",
            func: () =>
              member
                ? navigate(`/group/${id}/community`, { state: { type: "blog" } })
                : toast.error("그룹 가입 후 이용 가능합니다."),
          },
          notDataMessage: "소식이 존재하지 않습니다.",
        }}
        data={blog}
        clickSlide={() =>
          member
            ? navigate(`/group/${id}/community`, { state: { type: "blog" } })
            : toast.error("그룹 가입 후 이용 가능합니다.")
        }
        type="blog"
      />
    </HomeContainer>
  );
};

export default GroupHome;
